export default [
    {
        path: '/sales',
        meta: {
            title: "Sales",
            icon: "sales.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/Index'),
        redirect: { name: 'sales' },
        children: [
            {
                path: 'saleorder',
                name: 'sales',
                meta: {
                    title: "Sales Order",
                    show: true
                },
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/SaleOrder'),
            },
            {
                path: 'validation',
                name: 'sales.validation',
                meta: {
                    title: "Sales Order Validation",
                    show: true
                },
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/SaleOrderValidation'),
            },
            {
                path: 'saleorder/:id',
                name: 'sales.detail',
                meta: {
                    title: "Sale Order Detail",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/SaleOrderDetail'),
            },
            {
                path: 'saleorder/:id/:approval/:role_id',
                name: 'sales.detail.validation',
                meta: {
                    title: "Sale Order Detail",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/SaleOrderDetail'),
            },
            {
                path: 'calendar',
                name: 'sales.calendar',
                meta: {
                    title: "Calendar View",
                    show: true
                },
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/SalesPage/Calendar'),
            },
            {
                path: 'form',
                name: 'sales.form',
                meta: {
                    title: "Form",
                    show: false
                },
                component: () => import(/* webpackChunkName: "sales" */ '../views/admin/page/FormPage/Index'),
            },
            {
                path: 'dashboard',
                name: 'sales.dashboard',
                meta: {
                    title: "Sales Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "sales" */'../views/admin/page/SalesPage/SaleDashboard'),
            },
            {
                path: 'revision',
                name: 'sales.revision',
                meta: {
                    title: "Sale Order Revision",
                    show: true
                },
                component: () => import(/* webpackChunkName: "accounting" */'../views/admin/page/SalesPage/SaleOrderRevisionValidation'),
            },
        ]
    }
];